export default {"src":"/_next/static/media/business-continuity-and-disaster-recovery.f9ee6e1a.svg","height":506,"width":506,"blurWidth":0,"blurHeight":0};